import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { IgxDialogComponent, IgxInputDirective } from "igniteui-angular";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuUsersService } from "../../Services/menu-users.service";

@Component({
  selector: "menu-security-list",
  templateUrl: "./menu-security-list.component.html",
  styleUrls: ["./menu-security-list.component.css"],
})
export class MenuSecurityListComponent implements OnInit {
  @Input()
  rowData;

  @Output()
  gridSelection: EventEmitter<any> = new EventEmitter();

  @Output()
  create: EventEmitter<any> = new EventEmitter();

  @Output()
  copy: EventEmitter<any> = new EventEmitter();

  public columnDefs = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private detailCellRendererParams;

  constructor(
    private service: MenuUsersService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createGridColumnDefs(service);
  }

  ngOnInit() {}

  ngOnChanges() {}

  createGridColumnDefs(service: MenuUsersService) {
    this.columnDefs = [
      {
        headerName: "User",
        field: "user",
        filter: "agTextColumnFilter",
        cellRenderer: "agGroupCellRenderer",
      },
    ];

    this.detailCellRendererParams = {
      detailGridOptions: {
        headerName: "Top Row",

        columnDefs: [
          {
            headerName: "",
            field: "user",
            hide: true,
          },
          {
            headerName: "Menu",
            field: "menuName",
            filter: "agTextColumnFilter",
          },
        ],
        onFirstDataRendered(params) {
          setTimeout(() => params.api.sizeColumnsToFit(), 500);
        },
        rowSelection: "single",
        onRowSelected: (params) => {
          // Emit changes up to parent
          // Pass object { rowSelected: xxx, gridEvent: xxx }
          this.gridSelection.emit({
            rowSelected: this.gridApi.getSelectedRows(),
            gridEvent: params,
          });
        },
      },
      getDetailRowData: function (params) {
        // Get order line detail info
        service.getAllByUser(params.data.user).subscribe(
          (response) => {
            if (response.length > 0) {
              params.successCallback(response);
            } else {
              this.detailData = null;
              this.tstr.warning("No records found", "Warning");
            }
          },
          (error) => {
            this.tstr.error("Unexpected error occurred", "Error");
          }
        );
      },
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    setTimeout(() => params.api.sizeColumnsToFit(), 500);
  }

  onNewClick() {
    this.create.emit({});
  }

  onCopyClick() {
    this.copy.emit({});
  }

  onSelectionChanged(event) {
    // Emit changes up to parent
    // Pass object { rowSelected: xxx, gridEvent: xxx }
    this.gridSelection.emit({
      rowSelected: this.gridApi.getSelectedRows(),
      gridEvent: event,
    });
  }
}
